import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import Alert from 'component/utils/Alert'

class JustificationDemarcateEditForm extends Component {
  state = {
    alert: {
      show: false,
      message: '',
    },
  }

  static propTypes = {
    fields: PropTypes.object.isRequired,
    values: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    setValueToField: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    justification: PropTypes.object,
    updateJustification: PropTypes.func,
  }

  handleAlert = (message) => {
    this.setState((prevState) => ({
      alert: {
        show: !prevState.alert.show,
        message: message || '',
      },
    }))
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const { onSubmit, translate, justification } = this.props

    if (
      !justification.dsJustificationDemarcate ||
      justification.dsJustificationDemarcate.length === 0
    ) {
      return
    }
    if (justification.dsJustificationDemarcate.length > 200) {
      let msg = translate('demarcate.justification.dsJustificationMaxSize')
      msg = msg.replace('#', '200')
      this.handleAlert(msg)
      return
    }
    onSubmit(justification)
  }

  handleChange = (e) => {
    const { updateJustification, justification } = this.props
    updateJustification({
      ...justification,
      dsJustificationDemarcate: e.target.value,
    })
  }

  handleClean = () => {
    const { updateJustification } = this.props
    updateJustification({ dsJustificationDemarcate: '' })
  }

  render() {
    const { translate, fields, justification } = this.props

    const { alert } = this.state

    return (
      <form onSubmit={this.handleSubmit}>
        <Row>
          <Col lg={6} lgOffset={3} md={6} mdOffset={3} sm={12} xs={12}>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Field {...fields.dsJustificationDemarcate}>
                <Input
                  id='dsJustificationDemarcate'
                  {...fields.dsJustificationDemarcate.input}
                  value={justification.dsJustificationDemarcate}
                  onChange={(e) => this.handleChange(e)}
                />
              </Field>
            </Col>

            <Col lg={2} md={2} sm={12} xs={12} className='margin-top'>
              <button
                type='submit'
                style={{ border: '1px solid #72bf44' }}
                className='button button-primary button-full'
              >
                {justification.idJustificationDemarcate
                  ? translate('demarcate.justification.update')
                  : translate('demarcate.justification.register')}
              </button>
            </Col>

            <Col lg={2} md={2} sm={12} xs={12} className='margin-top'>
              <button
                type='button'
                className='button-hollow button-hollow-danger button-full'
                onClick={() => this.handleClean()}
              >
                {translate('demarcate.justification.clean')}
              </button>
            </Col>
          </Col>
        </Row>

        {alert.show && (
          <Alert
            handleAlert={this.handleAlert}
            text={translate(alert.message)}
            translate={translate}
            textButton={translate('irc.gama.closeAlert')}
            preventDefault
            size='sm'
          />
        )}
      </form>
    )
  }
}

const fields = ['dsJustificationDemarcate']

export default Form({ fields })(JustificationDemarcateEditForm)

export { JustificationDemarcateEditForm }
